import { ArrowLeft } from "lucide-react";

export const VowHeader = ({ roomNumber, onBack, children }) => (
  <div className="sticky top-0 z-10 bg-[#1c3b2e] text-white px-4 py-3">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {onBack && (
          <button onClick={onBack} className="p-1.5 -ml-1.5 rounded-full hover:bg-white/10 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            data-testid="back-button">
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        <div>
          <h1 className="text-xl font-bold tracking-tight leading-none">VOW</h1>
          <p className="text-[10px] font-medium tracking-[0.15em] text-[#bd9b5e] uppercase leading-none mt-0.5">Voyage of Wellness</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {children}
        {roomNumber && (
          <div className="bg-white/10 px-3 py-1.5 rounded-lg text-right">
            <p className="text-[9px] uppercase tracking-wider text-white/60 leading-none">Room</p>
            <p className="text-sm font-bold leading-none mt-0.5" data-testid="header-room-number">{roomNumber}</p>
          </div>
        )}
      </div>
    </div>
  </div>
);
